// extracted by mini-css-extract-plugin
export default {"modalWrapper":"styles_modalWrapper__jCct9","btnBlock":"styles_btnBlock__WD37V","mainBtn":"styles_mainBtn__kCzvQ"};